module.exports = __webpack_public_path__ + "static/img/bg-1.afc88215.webp";